module.exports = __webpack_public_path__ + "20f14386cf21227376ae17541a9fb8fd.svg";